export default [
  {
    path: '/security/user',
    name: 'IdentityUser',
    component: () => import('@/components/security/identity/IdentityUser'),
    meta: {
      title: 'Identity User',
      requiresAuth: true,
      services: ['IdentityUser']
    }
  },
  {
    path: '/security/role',
    name: 'IdentityRole',
    component: () => import('@/components/security/identity/IdentityRole'),
    meta: {
      title: 'Identity Role',
      requiresAuth: true,
      services: ['IdentityRole']
    }
  },
  {
    path: '/security/permission',
    name: 'IdentityPolicy',
    component: () => import('@/components/security/identity/IdentityPolicy'),
    meta: {
      title: 'Identity Permission',
      requiresAuth: true,
      services: ['IdentityPolicy']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/securityModule.js